import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "flex flex-col gap-6 md:gap-5 racq-max-w-xl5"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-6 md:gap-5"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col gap-6 md:gap-5"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 3,
  class: "mt-6 flex flex-col gap-6 md:gap-5 racq-max-w-xl5"
}

import { Portfolio, ProductContentFields } from '@/interfaces';
import InsuranceProductCard from '../InsuranceProductCard/InsuranceProductCard.vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import RoadsideProductCard from '../RoadsideProductCard/RoadsideProductCard.vue';
import { computed } from 'vue';
import PromoCardImage from '../PromoCardImage/PromoCardImage.vue';

export interface IProductCardList {
  hideAssistance?: boolean;
  hideInsurance?: boolean;
  hideBank?: boolean;
  portfolio?: Portfolio;
  fields?: ProductContentFields;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCardList',
  props: {
    hideAssistance: { type: Boolean },
    hideInsurance: { type: Boolean },
    hideBank: { type: Boolean },
    portfolio: {},
    fields: {}
  },
  setup(__props: any) {

const props = __props;
const noActiveProducts = computed(() => {
  const noInsurance = (props.portfolio?.insurancePolicies?.length ?? 0) === 0;
  const noAssistance = (props.portfolio?.assistanceProducts?.length ?? 0) === 0;
  const noBank = (props.portfolio?.bankingProducts?.length ?? 0) === 0;

  const hideInsurance = !!props.hideInsurance;
  const hideAssistance = !!props.hideAssistance;
  const hideBank = !!props.hideBank;

  // True iff every *visible* category has zero items.
  // Hidden categories are ignored.
  return (hideInsurance || noInsurance) && (hideAssistance || noAssistance) && (hideBank || noBank);
});

/**
 * To calculate product tile index for analytics
 * @param index
 * @param type
 */
const dataTestId = (index: number, type: 'insurance' | 'bank' | 'roadside') => {
  let i = 0;
  switch (type) {
    case 'insurance':
      i = index;
      break;
    case 'roadside':
      i = index + (props.hideInsurance ? 0 : (props.portfolio?.insurancePolicies?.length ?? 0));
      break;
    case 'bank':
      i =
        index +
        (props.hideInsurance ? 0 : (props.portfolio?.insurancePolicies?.length ?? 0)) +
        (props.hideAssistance ? 0 : (props.portfolio?.assistanceProducts?.length ?? 0));
      break;
    default:
      break;
  }
  return `product_tile_${i}`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.fields?.heading?.value)
      ? (_openBlock(), _createBlock(_unref(RichText), {
          key: 0,
          class: "text-xl-bold md:mb-5 mb-6",
          field: _ctx.fields?.heading
        }, null, 8, ["field"]))
      : _createCommentVNode("", true),
    (noActiveProducts.value)
      ? (_openBlock(), _createBlock(_unref(RichText), {
          key: 1,
          class: "text-base",
          field: _ctx.fields?.noActiveProductText
        }, null, 8, ["field"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.hideInsurance && _ctx.portfolio?.insurancePolicies?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portfolio?.insurancePolicies, (insurance, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(InsuranceProductCard, {
                      insuranceProduct: insurance,
                      fields: _ctx.fields,
                      dataTestId: dataTestId(index, 'insurance')
                    }, null, 8, ["insuranceProduct", "fields", "dataTestId"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.hideAssistance && _ctx.portfolio?.assistanceProducts?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.portfolio?.assistanceProducts, (rsa, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(RoadsideProductCard, {
                      assistanceProduct: rsa,
                      fields: _ctx.fields,
                      dataTestId: dataTestId(index, 'roadside')
                    }, null, 8, ["assistanceProduct", "fields", "dataTestId"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.hideBank && _ctx.portfolio?.bankingProducts?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(RoadsideProductCard, {
                  isBank: true,
                  fields: _ctx.fields,
                  dataTestId: dataTestId(0, 'bank')
                }, null, 8, ["fields", "dataTestId"])
              ]))
            : _createCommentVNode("", true)
        ])),
    (_ctx.fields?.crossSellPromo?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "h-4 bg-racq-neutral-grey" }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields?.crossSellPromo, (value, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(PromoCardImage, {
                fields: { items: [value] }
              }, null, 8, ["fields"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})